function positiveInteger(value) {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

function replaceTilePlaceholder(template, name, value) {
  return template.split(`{${name}}`).join(String(value));
}

export function isTiledPanorama(source) {
  return Boolean(source && typeof source === 'object' && source.type === 'equirectangular-tiles');
}

export function panoramaSourceKey(source) {
  if (!isTiledPanorama(source)) return `image:${String(source || '')}`;

  const levels = Array.isArray(source.levels)
    ? source.levels.map((level) => [
        positiveInteger(level?.width),
        positiveInteger(level?.cols),
        positiveInteger(level?.rows),
      ])
    : [];
  return JSON.stringify([
    'equirectangular-tiles',
    String(source.generation || ''),
    String(source.baseUrl || ''),
    String(source.tileUrlTemplate || ''),
    levels,
    positiveInteger(source.width),
    positiveInteger(source.cols),
    positiveInteger(source.rows),
  ]);
}

export function toViewerPanorama(source) {
  if (!isTiledPanorama(source)) return source;

  const template = String(source.tileUrlTemplate || '');
  const baseUrl = String(source.baseUrl || '');
  const levels = Array.isArray(source.levels)
    ? source.levels.map((level) => ({
        width: positiveInteger(level?.width),
        cols: positiveInteger(level?.cols),
        rows: positiveInteger(level?.rows),
      })).filter((level) => level.width && level.cols && level.rows)
    : [];
  const tileUrl = (col, row, level = 0) => {
    if (!template) return null;
    return replaceTilePlaceholder(
      replaceTilePlaceholder(
        replaceTilePlaceholder(template, 'level', level),
        'row',
        row
      ),
      'col',
      col
    );
  };

  if (levels.length) return { baseUrl: baseUrl || undefined, levels, tileUrl };

  const width = positiveInteger(source.width);
  const cols = positiveInteger(source.cols);
  const rows = positiveInteger(source.rows);
  if (!width || !cols || !rows) return source;
  return { baseUrl: baseUrl || undefined, width, cols, rows, tileUrl };
}
